import { RootState, Module, DataLogState } from '../types'

import { Find } from '@/api/data-logger'

export const datalog: Module<DataLogState, RootState> = {
  namespaced: true,
  state() {
    return {
      items: [],
    }
  },
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
  },
  actions: {
    async find({ commit }) {
      const items = await Find()
      commit('SET_ITEMS', items)
    },
  },
  getters: {
    items: (state) => state.items,
  },
}
